<template>
  <div class="flex space-x-5 flex-1">
    <aside class="space-y-3 flex-shrink-0 p-1 w-70 overflow-auto">
      <router-link
        v-for="(block, i) in blocks"
        :key="i"
        class="cursor-pointer flex space-x-2 bg-gray-100 rounded-2xl text-black py-3 px-4 block-item item group items-center"
        :to="{ name: 'articles-block-item', params: { id: block.id } }"
      >
        <div class="flex-1">
          <p
            class="font-medium m-0 text-base"
            :class="{ 'opacity-30': !block.title }"
          >
            {{
              block.title ||
              (block.items[0]?.title
                ? `[${block.items[0].title}]`
                : 'Без названия')
            }}
          </p>
          <p class="font-medium m-0 text-sm opacity-30">
            {{ blockKindMap[block.kind] ?? block.kind }}
          </p>
        </div>
      </router-link>

      <div
        class="cursor-pointer flex bg-gray-100 rounded-2xl py-2 px-6 group justify-center"
        @click="addBlock"
      >
        <Icon
          icon="ph:plus"
          width="24"
          class="opacity-20 transition-opacity group-hover:opacity-100"
        />
      </div>
    </aside>

    <div v-if="blocks.length" class="flex-1 overflow-auto">
      <router-view :key="blockId" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import Draggable from 'vuedraggable'
import { useBlocks } from '../composables/blocks'

export default {
  components: {
    Draggable
  },
  props: {
    blocks: {
      type: Array,
      default: () => []
    }
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const blockId = computed(() => route.params.id)
    const { blockKindMap, addBlock } = useBlocks({
      router,
      route
    })

    return {
      blockKindMap,
      addBlock,
      blockId
    }
  }
}
</script>

<style lang="postcss" scoped>
.block-item {
  outline: solid 2px transparent;
}
.block-item.router-link-active {
  @apply outline-solid-purple-500;
}
</style>
